module.exports = __webpack_public_path__ + "static/media/eng_d_2392.1be70215.mp4";